import { TeamRole } from '@anm/api/modules/team';
import FormHelperText from '@anm/components/form/FormHelperText';
import { DisplayNameRequiredField, EmailField } from '@anm/components/form/fields';
import { UserFormRow } from '@anm/styles/helpers';
import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Field, Form, FormRenderProps } from 'react-final-form';
import { UserTeamPermission } from 'types/user';

import TeamMemberRolesInput from '../TeamMemberRolesInput';

import Wrapper, { ButtonLoaderWrapper } from './Wrapper';

export type TeamMemberInviteFormProps = {
  isPending?: boolean;
  permissions?: UserTeamPermission;
  submitError?: string | null;
};

export type TeamMemberInviteFormFields = { displayName: string; email: string; role: TeamRole };

const renderForm = ({ submitError, isPending = false, permissions }: TeamMemberInviteFormProps) => ({
  form,
  handleSubmit
}: FormRenderProps<TeamMemberInviteFormFields>) => {
  const { dirty } = form.getState();

  return (
    <form onSubmit={handleSubmit}>
      <Wrapper>
        {submitError && (
          <UserFormRow>
            <FormHelperText variant="static">{submitError}</FormHelperText>
          </UserFormRow>
        )}

        <UserFormRow>
          <DisplayNameRequiredField inputVariant="simple" placeholder="Enter member name" labelVariant="static-above" />
        </UserFormRow>
        <UserFormRow>
          <EmailField
            autoFocus={false}
            placeholder="Enter member email"
            inputVariant="simple"
            labelVariant="static-above"
          />
        </UserFormRow>
        <UserFormRow>
          <Field name="role" permissions={permissions} component={TeamMemberRolesInput} isVisibleOwnerRole={false} />
        </UserFormRow>
        <UserFormRow>
          <ButtonLoaderWrapper
            buttonType="submit"
            size="large"
            variant={dirty ? 'light-blue' : 'gray-border'}
            disabled={!dirty}
            isPending={isPending}
          >
            Send invite
          </ButtonLoaderWrapper>
        </UserFormRow>
      </Wrapper>
    </form>
  );
};

const TeamMemberInviteForm: FC<FinalFormConfig<TeamMemberInviteFormFields> & TeamMemberInviteFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default TeamMemberInviteForm;
